<template>
  <div class="ord-root" :data-sidebar="darkMode ? 'dark' : 'light'">
    <div class="ord-topbar">
      <div class="container d-flex align-items-center gap-3">
        <a href="javascript:void(0)" @click="$router.push('/')"><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:32px;" /></a>
        <button class="btn btn-sm btn-link text-muted p-0" @click="$router.push('/orders')"><i class="mdi mdi-arrow-left me-1"></i>Orders</button>
      </div>
    </div>
    <div class="container ord-container">
      <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>
      <div v-else-if="loadError" class="text-center py-5">
        <i class="mdi mdi-cloud-off-outline" style="font-size:48px;color:#FF6B6B;"></i>
        <p class="mt-2" style="color:var(--fm-h,#F5F0E8);font-weight:600;">{{ loadError }}</p>
        <div class="mt-3 d-flex gap-2 justify-content-center">
          <button class="btn btn-sm btn-warning" @click="load"><i class="mdi mdi-refresh me-1"></i>Retry</button>
          <button class="btn btn-sm btn-outline-secondary" @click="$router.push('/orders')"><i class="mdi mdi-arrow-left me-1"></i>Back to Orders</button>
        </div>
      </div>
      <div v-else-if="!order.id" class="text-center py-5"><i class="mdi mdi-alert-circle" style="font-size:48px;color:#FF6B6B;"></i><p class="mt-2" style="color:var(--fm-s,#777);">Order not found</p></div>
      <div v-else class="row g-4">
        <div class="col-lg-7">
          <div class="p2c mb-3">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <div><span style="font-size:13px;color:var(--fm-s,#777);font-family:monospace;">#{{ order.order_number }}</span>
                <span class="p2b ms-2" :class="'st-'+order.status">{{ (order.status||'').replace(/_/g,' ') }}</span></div>
              <span style="color:var(--fm-s,#777);font-size:12px;">{{ fmtD(order.created_at) }}</span>
            </div>
            <div class="d-flex align-items-center gap-3">
              <div class="p2t"><img v-if="order.listing_photo" :src="pu(order.listing_photo)" /><i v-else class="mdi mdi-paw" style="font-size:28px;color:#BFA164;"></i></div>
              <div class="flex-fill"><div style="font-size:15px;font-weight:600;">{{ order.listing_title }}</div><div class="p2s">Qty: {{ order.quantity }}</div></div>
              <div style="font-size:18px;font-weight:700;color:#BFA164;">KES {{ fN(order.total_amount) }}</div>
            </div>
          </div>
          <div class="p2c mb-3">
            <h6 class="p2h"><i class="mdi mdi-timeline me-2"></i>Timeline</h6>
            <div style="padding-left:20px;">
              <div v-for="(s,i) in steps" :key="i" class="tli" :class="{done:isAf(s.k)}"><div class="tld"></div><div><div style="font-size:13px;font-weight:600;color:var(--fm-h,#F5F0E8);">{{ s.l }}</div></div></div>
            </div>
          </div>
          <div class="p2c mb-3" v-if="order.transport_option">
            <h6 class="p2h"><i class="mdi mdi-truck me-2"></i>Delivery</h6>
            <div class="p2s">{{ order.transport_option==='buyer_collects'?'Buyer Collects':'Seller Delivers' }}</div>
            <div v-if="order.delivery_location" class="p2s mt-1">Location: {{ order.delivery_location }}</div>
          </div>
        </div>
        <div class="col-lg-5">
          <div class="p2c mb-3">
            <h6 class="p2h"><i class="mdi mdi-receipt me-2"></i>Payment</h6>
            <div class="p2l"><span>Subtotal</span><span>KES {{ fN(order.subtotal) }}</span></div>
            <div class="p2l"><span>Platform Fee</span><span>KES {{ fN(order.platform_fee) }}</span></div>
            <div v-if="Number(order.transport_fee)>0" class="p2l"><span>Transport</span><span>KES {{ fN(order.transport_fee) }}</span></div>
            <div class="p2l" style="font-size:16px;font-weight:700;color:var(--fm-h,#1A1A1A);border-top:2px solid #BFA164;border-bottom:none;padding-top:10px;margin-top:4px;"><span>Total</span><span>KES {{ fN(order.total_amount) }}</span></div>
            <div v-if="order.escrow" style="display:flex;align-items:center;padding:8px 12px;background:rgba(80,200,120,.06);border:1px solid rgba(80,200,120,.2);border-radius:8px;color:#50C878;font-size:12px;margin-top:12px;"><i class="mdi mdi-shield-check me-2"></i>Escrow: {{ order.escrow.status }}</div>
          </div>
          <div class="p2c mb-3">
            <h6 class="p2h"><i class="mdi mdi-account-multiple me-2"></i>Parties</h6>
            <div class="p2s mb-2"><strong style="color:#BFA164;">Buyer:</strong> {{ order.buyer_name || 'Unknown' }}</div>
            <div class="p2s"><strong style="color:#BFA164;">Seller:</strong> {{ order.seller_name || 'Unknown' }}</div>
          </div>
          <div class="p2c mb-3">
            <h6 class="p2h"><i class="mdi mdi-gesture-tap me-2"></i>Actions</h6>

            <!-- CART GROUP CHECKOUT — shows for orders that are part of a multi-seller cart payment.
                 Replaces the per-order STK box so the buyer doesn't double-pay. -->
            <div v-if="order.order_group_id && (order.status==='pending_payment'||order.status==='payment_initiated'||order.status==='stk_sent') && isBuyer" class="od-pay-box mb-3">
              <div class="od-pay-header"><i class="mdi mdi-cart-outline me-1" style="color:#BFA164;"></i>Part of a Cart Checkout</div>
              <div style="font-size:12px;color:var(--fm-m,#A09888);margin:8px 0 12px;line-height:1.5;">
                This order was paid for as part of a multi-seller cart. <span v-if="order.siblings && order.siblings.length">There are {{ order.siblings.length }} other order{{ order.siblings.length===1?'':'s' }} in the same payment.</span>
                <span v-if="!groupPaymentCompleted"> Once the M-Pesa prompt is paid, all orders in the group flip to <strong style="color:#50C878;">paid</strong> at the same time.</span>
              </div>

              <!-- Group payment status indicator -->
              <div v-if="order.groupPayment" class="mt-2 mb-3" style="padding:10px;border-radius:8px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);">
                <div style="font-size:11px;color:var(--fm-s,#6B6356);text-transform:uppercase;letter-spacing:.5px;">Cart payment status</div>
                <div class="d-flex align-items-center gap-2 mt-1">
                  <span v-if="order.groupPayment.status==='completed'" style="color:#50C878;font-weight:600;font-size:13px;"><i class="mdi mdi-check-circle me-1"></i>Paid · KES {{ formatPrice(order.groupPayment.amount) }}</span>
                  <span v-else-if="order.groupPayment.status==='stk_sent'||order.groupPayment.status==='initiated'" style="color:#FFAB00;font-weight:600;font-size:13px;"><i class="mdi mdi-clock-outline me-1"></i>Waiting for PIN · KES {{ formatPrice(order.groupPayment.amount) }}</span>
                  <span v-else-if="order.groupPayment.status==='cancelled'" style="color:#FF6B6B;font-weight:600;font-size:13px;"><i class="mdi mdi-close-circle me-1"></i>Cancelled</span>
                  <span v-else-if="order.groupPayment.status==='failed'" style="color:#FF6B6B;font-weight:600;font-size:13px;"><i class="mdi mdi-alert me-1"></i>Failed</span>
                  <span v-else style="color:var(--fm-m,#A09888);font-size:13px;text-transform:capitalize;">{{ order.groupPayment.status }}</span>
                </div>
                <div v-if="order.groupPayment.payer_phone" style="font-size:11px;color:var(--fm-s,#6B6356);margin-top:2px;">Sent to +{{ order.groupPayment.payer_phone }}</div>
              </div>

              <!-- Siblings list -->
              <div v-if="order.siblings && order.siblings.length" class="mt-2 mb-3">
                <div style="font-size:11px;color:var(--fm-s,#6B6356);text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px;">Sibling orders in this cart</div>
                <div v-for="s in order.siblings" :key="s.id" style="display:flex;justify-content:space-between;align-items:center;padding:6px 0;border-bottom:1px solid var(--fm-br,#1E1E1E);font-size:12px;">
                  <a href="javascript:void(0)" @click="$router.push('/orders/'+s.id)" style="color:#BFA164;text-decoration:none;font-family:monospace;">{{ s.order_number }}</a>
                  <span style="color:var(--fm-m,#A09888);">KES {{ formatPrice(s.total_amount) }}</span>
                  <span class="od-status" :class="'st-'+s.status" style="font-size:10px;">{{ (s.status||'').replace(/_/g,' ') }}</span>
                </div>
              </div>

              <div class="d-flex gap-2 flex-wrap">
                <button class="btn btn-sm btn-outline-warning" @click="load" :disabled="loading"><i class="mdi mdi-refresh me-1"></i>Refresh status</button>
                <button v-if="!groupPaymentCompleted" class="btn btn-sm btn-warning" @click="resendCartStk" :disabled="resendingCart"><span v-if="resendingCart" class="spinner-border spinner-border-sm me-1"></span><i v-else class="mdi mdi-cellphone-wireless me-1"></i>Resend M-Pesa Prompt</button>
              </div>

              <div v-if="resendCartError" class="mt-2" style="color:#FF6B6B;font-size:12px;">{{ resendCartError }}</div>
              <div v-if="resendCartSent" class="mt-2" style="color:#50C878;font-size:12px;"><i class="mdi mdi-check-circle me-1"></i>New M-Pesa prompt sent. Check your phone.</div>
            </div>

            <!-- PAYMENT NEEDED (single-order legacy flow — hidden when this order is part of a cart group) -->
            <div v-if="!order.order_group_id && (order.status==='pending_payment'||order.status==='payment_initiated'||order.status==='stk_sent')&&isBuyer">
              <div class="od-pay-box mb-3">
                <div class="od-pay-header"><i class="mdi mdi-cellphone me-1" style="color:#50C878;"></i> Pay via M-Pesa</div>
                <div class="od-pay-amount">KES {{ formatPrice(order.total_amount) }}</div>
                <div style="margin-top:12px;">
                  <label class="p2s" style="margin-bottom:4px;display:block;">M-Pesa Phone Number</label>
                  <div style="display:flex;gap:8px;">
                    <div style="flex:1;position:relative;">
                      <span style="position:absolute;left:12px;top:50%;transform:translateY(-50%);color:var(--fm-s,#777);font-size:13px;">+254</span>
                      <input v-model="payPhone" type="tel" maxlength="10" placeholder="7XX XXX XXX" style="width:100%;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);border-radius:8px;padding:10px 12px 10px 52px;color:#1A1A1A;font-size:14px;" />
                    </div>
                    <button class="btn btn-warning fw-bold" @click="sendStkFromOrder" :disabled="stkSending" style="white-space:nowrap;">
                      <span v-if="stkSending"><span class="spinner-border spinner-border-sm me-1"></span></span>
                      <span v-else><i class="mdi mdi-send me-1"></i>Send Prompt</span>
                    </button>
                  </div>
                </div>

                <!-- STK STATUS -->
                <div v-if="stkStatus==='sent'" class="od-stk-status mt-3" style="background:rgba(80,200,120,0.06);border-color:rgba(80,200,120,0.2);">
                  <div class="d-flex align-items-center gap-2"><div class="ck-pulse"></div><span style="color:#50C878;font-weight:600;font-size:13px;">Waiting for M-Pesa PIN</span></div>
                  <div class="p2s mt-1">Check <strong style="color:var(--fm-h,#F5F0E8);">+254{{ payPhone }}</strong> and enter PIN</div>
                  <div class="p2s mt-1"><i class="mdi mdi-refresh mdi-spin me-1"></i>Checking... ({{ stkCountdown }}s)</div>
                </div>
                <div v-if="stkStatus==='completed'" class="od-stk-status mt-3" style="background:rgba(80,200,120,0.08);border-color:rgba(80,200,120,0.2);">
                  <i class="mdi mdi-check-circle" style="color:#50C878;font-size:24px;"></i>
                  <span style="color:#50C878;font-weight:600;">Payment Confirmed!</span>
                  <div v-if="stkReceipt" class="p2s mt-1">Receipt: <strong style="color:var(--fm-h,#F5F0E8);">{{ stkReceipt }}</strong></div>
                </div>
                <div v-if="stkStatus==='failed'||stkStatus==='cancelled'" class="od-stk-status mt-3" style="background:rgba(255,107,107,0.06);border-color:rgba(255,107,107,0.15);">
                  <i class="mdi mdi-close-circle" style="color:#FF6B6B;font-size:20px;"></i>
                  <span style="color:#FF6B6B;font-weight:600;">{{ stkStatus==='cancelled'?'Cancelled':'Failed' }}</span>
                  <div class="p2s mt-1">{{ stkError || 'Try again with a different number.' }}</div>
                </div>
              </div>

              <!-- MANUAL PAYBILL OPTION -->
              <div class="od-pay-box">
                <div style="font-size:12px;color:var(--fm-s,#777);margin-bottom:8px;"><i class="mdi mdi-bank me-1"></i>Or pay manually via M-Pesa Paybill</div>
                <div class="od-paybill-rows">
                  <div><span>Paybill</span><strong style="color:#BFA164;">4160303</strong></div>
                  <div><span>Account</span><strong>{{ order.order_number }}</strong></div>
                  <div><span>Amount</span><strong style="color:#50C878;">KES {{ formatPrice(order.total_amount) }}</strong></div>
                </div>
              </div>

              <button class="btn btn-outline-danger btn-sm w-100 mt-3" @click="confirmAction('cancelled','Cancel Order','Are you sure you want to cancel this order?','danger')"><i class="mdi mdi-close me-1"></i>Cancel Order</button>
            </div>

            <!-- SELLER ACTIONS -->
            <div v-else-if="order.status==='paid'&&isSeller" class="d-grid gap-2"><button class="btn btn-warning fw-bold" @click="confirmAction('confirmed','Confirm Order','You are confirming this order and will begin preparing it for the buyer. Proceed?','success')"><i class="mdi mdi-check me-1"></i>Confirm & Prepare</button><button class="btn btn-outline-danger btn-sm" @click="confirmAction('cancelled','Decline Order','Are you sure you want to decline this order? The buyer will be refunded.','danger')">Decline Order</button></div>
            <div v-else-if="order.status==='confirmed'&&isSeller" class="d-grid"><button class="btn btn-warning fw-bold" @click="confirmAction('in_transit','Mark In Transit','Confirm that this order has been shipped or is on the way to the buyer.','success')"><i class="mdi mdi-truck-fast me-1"></i>Mark Shipped / In Transit</button></div>
            <div v-else-if="order.status==='in_transit'&&isSeller" class="d-grid"><button class="btn btn-warning fw-bold" @click="confirmAction('delivered','Mark Delivered','Confirm that the animal has been delivered to the buyer. The buyer will have 48 hours to inspect.','success')"><i class="mdi mdi-truck-check me-1"></i>Mark Delivered</button></div>
            <!-- AUTO-RELEASE COUNTDOWN (shown to both buyer & seller) -->
            <div v-if="(order.status==='delivered'||order.status==='inspection')&&releaseSeconds>0" class="od-countdown mb-3">
              <div class="od-countdown-icon"><i class="mdi mdi-timer-sand"></i></div>
              <div class="od-countdown-label">{{ isBuyer ? 'Inspection window closes in' : 'Auto-release in' }}</div>
              <div class="od-countdown-time">{{ releaseDisplay }}</div>
              <div class="od-countdown-bar"><div class="od-countdown-fill" :style="{width: releasePct+'%'}"></div></div>
              <div class="od-countdown-hint" v-if="isBuyer">Confirm receipt or raise a dispute before the timer runs out. Payment will auto-release to the seller when this expires.</div>
              <div class="od-countdown-hint" v-else>Payment will be released to your wallet once the inspection window expires, unless the buyer raises a dispute.</div>
            </div>
            <div v-else-if="(order.status==='delivered'||order.status==='inspection')&&releaseExpired" class="od-countdown od-countdown-expired mb-3">
              <div class="od-countdown-icon"><i class="mdi mdi-check-circle"></i></div>
              <div class="od-countdown-label">Inspection window expired</div>
              <div class="od-countdown-hint">Payment is being auto-released to the seller.</div>
            </div>

            <div v-if="(order.status==='delivered'||order.status==='inspection')&&isBuyer" class="d-grid gap-2"><button class="btn btn-success fw-bold" @click="confirmAction('completed','Release Payment','You are confirming that you received the animal and are satisfied. Payment of KES '+formatPrice(sellerPayout)+' will be released to the seller. This cannot be undone.','warning')"><i class="mdi mdi-check-all me-1"></i>Confirm Receipt & Release Payment</button><button class="btn btn-outline-danger btn-sm" @click="raiseDispute"><i class="mdi mdi-alert me-1"></i>Raise Dispute</button></div>
            <div v-else-if="order.status==='completed'" class="text-center py-2"><i class="mdi mdi-check-circle" style="font-size:28px;color:#50C878;"></i><div class="p2s mt-2">Order completed</div><button v-if="isBuyer" class="btn btn-warning btn-sm mt-2" @click="leaveReview"><i class="mdi mdi-star me-1"></i>Leave Review</button></div>
            <div v-else class="p2s text-center py-2">No actions available</div>
            <div v-if="actMsg" class="mt-2 text-center" :style="{color:actOk?'#50C878':'#FF6B6B',fontSize:'12px'}">{{ actMsg }}</div>
          </div>

          <!-- CONFIRMATION MODAL -->
          <div v-if="showConfirm" class="od-modal-overlay" @click.self="!actLoading?showConfirm=false:null">
            <div class="od-modal">
              <div class="od-modal-icon" :class="'od-modal-'+confirmType">
                <i :class="confirmType==='danger'?'mdi mdi-alert-circle':confirmType==='warning'?'mdi mdi-alert':'mdi mdi-check-circle'"></i>
              </div>
              <h6 class="od-modal-title">{{ confirmTitle }}</h6>
              <p class="od-modal-msg">{{ confirmMsg }}</p>
              <!-- Extra warning for payment release -->
              <div v-if="confirmStatus==='completed'" class="od-release-box mt-3">
                <div class="od-release-row"><span>Amount to seller</span><strong style="color:#50C878;">KES {{ formatPrice(sellerPayout) }}</strong></div>
                <div class="od-release-row"><span>Seller</span><strong style="color:var(--fm-h,#F5F0E8);">{{ order.seller_name }}</strong></div>
                <div class="od-release-row"><span>Order</span><strong style="color:#BFA164;">{{ order.order_number }}</strong></div>
              </div>
              <div class="d-flex gap-2 mt-3">
                <button class="btn btn-outline-secondary flex-fill" @click="showConfirm=false" :disabled="actLoading">Cancel</button>
                <button class="btn flex-fill fw-bold" :class="confirmType==='danger'?'btn-danger':confirmType==='warning'?'btn-warning text-dark':'btn-success'" @click="executeConfirmed" :disabled="actLoading">
                  <span v-if="actLoading"><span class="spinner-border spinner-border-sm me-1"></span>Processing...</span>
                  <span v-else>{{ confirmTitle }}</span>
                </button>
              </div>
            </div>
          </div>

          <!-- PAYMENT RELEASED SUCCESS MODAL -->
          <div v-if="showReleaseSuccess" class="od-modal-overlay" @click.self="showReleaseSuccess=false">
            <div class="od-modal">
              <div class="od-release-success-icon"><i class="mdi mdi-check-bold"></i></div>
              <h5 style="color:#50C878;font-weight:700;margin-bottom:4px;">Payment Released!</h5>
              <p class="od-modal-msg">You have confirmed receipt of the animal.</p>
              <div class="od-release-box mt-3">
                <div class="od-release-row"><span>Released to seller</span><strong style="color:#50C878;">KES {{ formatPrice(releasedAmount) }}</strong></div>
                <div class="od-release-row"><span>Seller</span><strong style="color:var(--fm-h,#F5F0E8);">{{ releasedSeller }}</strong></div>
                <div class="od-release-row"><span>Order</span><strong style="color:#BFA164;">{{ releasedOrder }}</strong></div>
              </div>
              <div style="background:rgba(80,200,120,0.06);border:1px solid rgba(80,200,120,0.15);border-radius:8px;padding:10px 12px;margin-top:14px;">
                <div style="font-size:11px;color:#666666;"><i class="mdi mdi-shield-check me-1" style="color:#50C878;"></i>Transaction complete. Funds have been credited to the seller's wallet.</div>
              </div>
              <button class="btn btn-success fw-bold w-100 mt-3" @click="showReleaseSuccess=false"><i class="mdi mdi-check me-1"></i>Done</button>
            </div>
          </div>
          <button v-if="otherPartyId" class="btn btn-outline-warning w-100" @click="messageOther"><i class="mdi mdi-message-text me-1"></i>Message {{ isBuyer?'Seller':'Buyer' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
</style>

<style>
:root{
  --fm-h:#F5F0E8;
  --fm-s:#6B6356;
  --fm-m:#A09888;
  --fm-bg1:#141414;
  --fm-bg2:#0F0F0F;
  --fm-bg3:#1E1E1E;
  --fm-br:#1E1E1E;
  --fm-page:#0A0A0A;
}
html[data-theme="light"]{
  --fm-h:#1A1A1A;
  --fm-s:#777;
  --fm-m:#555;
  --fm-bg1:#FFFFFF;
  --fm-bg2:#F7F5F2;
  --fm-bg3:#F0EBE4;
  --fm-br:#E8E2DA;
  --fm-page:#F7F5F2;
}
html[data-theme="light"] body,
html[data-theme="light"] #layout-wrapper,
html[data-theme="light"] .ord-root,
html[data-theme="light"] .ord-container{
  background:var(--fm-page)!important;
  color:var(--fm-h)!important;
}
html[data-theme="dark"] body,
html[data-theme="dark"] #layout-wrapper,
html[data-theme="dark"] .ord-root,
html[data-theme="dark"] .ord-container{
  background:var(--fm-page)!important;
  color:var(--fm-h)!important;
}
html[data-theme="light"] .ord-topbar{
  background:#FFFFFF!important;
  border-bottom-color:#E8E2DA!important;
}
html[data-theme="dark"] .ord-topbar{
  background:var(--fm-bg1,#141414)!important;
}
html[data-theme="light"] .p2c,
html[data-theme="light"] .od-modal,
html[data-theme="light"] .od-pay-box,
html[data-theme="light"] .od-countdown,
html[data-theme="light"] .od-release-box{
  background:#FFFFFF!important;
  border-color:#E8E2DA!important;
  color:#1A1A1A!important;
}
html[data-theme="light"] .p2h,
html[data-theme="light"] .od-modal-title,
html[data-theme="light"] .od-pay-header,
html[data-theme="light"] .od-paybill-rows strong,
html[data-theme="light"] .od-release-row strong{
  color:#1A1A1A!important;
}
html[data-theme="light"] .p2s,
html[data-theme="light"] .p2l,
html[data-theme="light"] .od-modal-msg,
html[data-theme="light"] .od-countdown-label,
html[data-theme="light"] .od-countdown-hint,
html[data-theme="light"] .od-release-row{
  color:#555!important;
}
html[data-theme="light"] .p2t{
  background:#F0EBE4!important;
}
html[data-theme="light"] .od-paybill-rows>div{
  background:#F7F5F2!important;
  color:#555!important;
}
html[data-theme="light"] input,
html[data-theme="light"] textarea,
html[data-theme="light"] select{
  background:#FFFFFF!important;
  color:#1A1A1A!important;
  border-color:#E0D8D0!important;
}
html[data-theme="light"] .od-countdown-time{
  color:#1A1A1A!important;
}
html[data-theme="light"] .tli{border-left-color:#E0D8D0!important;}
html[data-theme="light"] .tld{background:#E0D8D0!important;border-color:#E0D8D0!important;}
html[data-theme="light"] .tli.done .tld{background:#50C878!important;border-color:#50C878!important;}
</style>

<style scoped>
.ord-root{background:var(--fm-page,#0A0A0A)!important;min-height:100vh;color:var(--fm-h,#F5F0E8)}
.ord-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414)!important;backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.ord-container{padding-top:80px;padding-bottom:60px;max-width:1000px;}
.p2c{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:20px}
.p2h{font-size:14px;font-weight:700;color:var(--fm-h,#F5F0E8);margin-bottom:14px}
.p2s{font-size:12px;color:var(--fm-m,#A09888)}
.p2t{width:60px;height:60px;border-radius:8px;overflow:hidden;background:var(--fm-bg2,#0F0F0F);flex-shrink:0;display:flex;align-items:center;justify-content:center}
.p2t img{width:100%;height:100%;object-fit:cover}
.p2l{display:flex;justify-content:space-between;padding:7px 0;font-size:13px;color:var(--fm-m,#A09888);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.p2b{font-size:10px;font-weight:600;padding:2px 8px;border-radius:10px;text-transform:capitalize}
.st-pending_payment{background:rgba(255,171,0,.15);color:#FFAB00}
.st-paid{background:rgba(80,200,120,.15);color:#50C878}
.st-confirmed{background:rgba(80,165,241,.15);color:#50a5f1}
.st-delivered{background:rgba(155,89,182,.15);color:#9b59b6}
.st-completed{background:rgba(80,200,120,.2);color:#50C878}
.st-cancelled{background:rgba(255,107,107,.15);color:#FF6B6B}
.st-payment_initiated{background:rgba(255,171,0,.15);color:#FFAB00}
.st-stk_sent{background:rgba(255,171,0,.15);color:#FFAB00}
.st-in_transit{background:rgba(155,89,182,.15);color:#9b59b6}
.st-inspection{background:rgba(80,165,241,.15);color:#50a5f1}
.st-disputed{background:rgba(255,107,107,.15);color:#FF6B6B}
.tli{position:relative;padding-bottom:20px;padding-left:16px;border-left:2px solid #2A2520}
.tli.done{border-left-color:#50C878}
.tli:last-child{border-left:none;padding-bottom:0}
.tld{position:absolute;left:-7px;top:2px;width:12px;height:12px;border-radius:50%;background:#2A2520;border:2px solid #2A2520}
.tli.done .tld{background:#50C878;border-color:#50C878}
.od-modal-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.7);z-index:1000;display:flex;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(4px)}
.od-modal{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#2A2520);border-radius:14px;padding:28px;max-width:400px;width:100%;text-align:center;animation:modalIn .2s ease-out}
@keyframes modalIn{from{opacity:0;transform:scale(0.9)}to{opacity:1;transform:scale(1)}}
.od-modal-icon{width:56px;height:56px;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 14px;font-size:28px}
.od-modal-success{background:rgba(80,200,120,0.12);color:#50C878}
.od-modal-warning{background:rgba(255,171,0,0.12);color:#FFAB00}
.od-modal-danger{background:rgba(255,107,107,0.12);color:#FF6B6B}
.od-modal-title{color:var(--fm-h,#F5F0E8);font-size:16px;font-weight:700;margin-bottom:8px}
.od-modal-msg{color:var(--fm-m,#A09888);font-size:13px;line-height:1.5;margin:0}
.od-release-box{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:12px;display:flex;flex-direction:column;gap:8px}
.od-release-row{display:flex;justify-content:space-between;align-items:center;font-size:13px;color:var(--fm-m,#A09888)}
.od-release-row strong{font-size:14px}
.od-release-success-icon{width:64px;height:64px;border-radius:50%;background:rgba(80,200,120,0.15);display:flex;align-items:center;justify-content:center;margin:0 auto 14px}
.od-release-success-icon i{font-size:32px;color:#50C878}
.od-pay-box{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px}
.od-pay-header{font-size:14px;font-weight:600;color:var(--fm-h,#F5F0E8);margin-bottom:4px}
.od-pay-amount{font-size:24px;font-weight:700;color:#BFA164}
.od-stk-status{display:flex;flex-direction:column;align-items:center;gap:4px;padding:14px;border:1px solid;border-radius:8px;text-align:center}
.od-paybill-rows{display:flex;flex-direction:column;gap:6px}
.od-paybill-rows>div{display:flex;justify-content:space-between;padding:6px 10px;background:var(--fm-bg1,#141414);border-radius:6px;font-size:12px;color:#777777}
.od-paybill-rows strong{color:var(--fm-h,#F5F0E8);font-size:13px}
.ck-pulse{width:10px;height:10px;border-radius:50%;background:#50C878;animation:odpulse 1.5s infinite}
@keyframes odpulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:0.5;transform:scale(1.3)}}
.od-countdown{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#2A2520);border-radius:12px;padding:16px;text-align:center}
.od-countdown-icon{font-size:28px;color:#FFAB00;margin-bottom:4px}
.od-countdown-icon .mdi-check-circle{color:#50C878}
.od-countdown-label{font-size:12px;color:#666666;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:8px}
.od-countdown-time{font-size:32px;font-weight:700;color:#1A1A1A;font-family:monospace;letter-spacing:2px;margin-bottom:10px}
.od-countdown-bar{height:4px;background:#2A2520;border-radius:2px;overflow:hidden}
.od-countdown-fill{height:100%;background:linear-gradient(90deg,#FF6B6B,#FFAB00,#50C878);border-radius:2px;transition:width 1s linear}
.od-countdown-hint{font-size:11px;color:#777777;margin-top:10px;line-height:1.4}
.od-countdown-expired{border-color:#50C878}
.od-countdown-expired .od-countdown-icon{color:#50C878}
.od-countdown-expired .od-countdown-label{color:#50C878}
</style>
<script>
/* eslint-disable */
import { execute, executeJson, flocker, uploads } from "@/api";

function applyOrderTheme(vm) {
  const t = document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || (vm && vm.darkMode ? 'dark' : 'light');
  const isDark = t !== 'light';
  if (vm) vm.darkMode = isDark;
  window.__flockrSetTheme(isDark ? 'dark' : 'light');

  if (document.body) {
    document.body.setAttribute('data-sidebar', isDark ? 'dark' : 'light');
    document.body.style.background = isDark ? '#0A0A0A' : '#F7F5F2';
    document.body.style.color = isDark ? '#F5F0E8' : '#1A1A1A';
  }

  const wrapper = document.getElementById('layout-wrapper');
  if (wrapper) {
    wrapper.style.background = isDark ? '#0A0A0A' : '#F7F5F2';
    wrapper.style.color = isDark ? '#F5F0E8' : '#1A1A1A';
  }
}

export default {
  name:"OrderDetail",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,
    loading:true,loadError:'',order:{},actMsg:'',actOk:false,actLoading:false,showConfirm:false,confirmTitle:'',confirmMsg:'',confirmType:'success',confirmStatus:'',showReleaseSuccess:false,releasedAmount:0,releasedSeller:'',releasedOrder:'',payPhone:'',stkSending:false,stkStatus:'',stkError:'',stkReceipt:'',stkRef:'',stkCheckoutId:'',stkTimer:null,stkCountdown:5,releaseSeconds:0,releaseTimer:null,releaseExpired:false,releaseTotalSecs:172800,
    // Cart-group resend state
    resendingCart:false, resendCartError:'', resendCartSent:false,
    steps:[{k:'pending_payment',l:'Order Created'},{k:'paid',l:'Payment Received'},{k:'confirmed',l:'Seller Confirmed'},{k:'in_transit',l:'In Transit'},{k:'delivered',l:'Delivered'},{k:'inspection',l:'Inspection'},{k:'completed',l:'Completed'}]
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    groupPaymentCompleted(){return this.order && this.order.groupPayment && this.order.groupPayment.status === 'completed';},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},

    isBuyer(){return String(this.order.buyer_id)===sessionStorage.getItem('userId')},
    isSeller(){return String(this.order.seller_id)===sessionStorage.getItem('userId')},
    otherPartyId(){var id=this.isBuyer?this.order.seller_id:this.order.buyer_id;return(id&&id!=='undefined'&&id!=='null')?id:null},
    sellerPayout(){var amt=Number(this.order.subtotal||0);if(this.order.transport_option==='seller_delivers')amt+=Number(this.order.transport_fee||0);return amt},
    releaseDisplay(){var s=this.releaseSeconds;if(s<=0)return'00:00:00';var h=Math.floor(s/3600);var m=Math.floor((s%3600)/60);var sec=s%60;return(h<10?'0':'')+h+':'+(m<10?'0':'')+m+':'+(sec<10?'0':'')+sec},
    releasePct(){if(this.releaseTotalSecs<=0)return 0;return Math.max(0,Math.min(100,(this.releaseSeconds/this.releaseTotalSecs)*100))}
  },
  mounted(){
    try { applyOrderTheme(this); } catch(e) { /* tolerate first-paint theme glitches */ }
    // Wrap the observer callback — without this, an exception during a Vue unmount mid-navigation
    // surfaces as an "Uncaught" error in the console with no stack pointing back here.
    this.themeObserver = new MutationObserver(() => {
      try { applyOrderTheme(this); } catch(e) { /* component may be unmounting; ignore */ }
    });
    try {
      this.themeObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-theme']
      });
    } catch(e) { /* unlikely — keep going */ }
    document.title = 'FLOCKR | Order';
    this.load();
  },
  beforeUnmount(){if(this.themeObserver)this.themeObserver.disconnect();this.stopStkPoll();this.stopReleaseTimer();},
  methods:{
    pu(p){if(!p)return'';if(p.startsWith&&p.startsWith('http'))return p;return uploads+String(p).replace('uploads/','')},
    fN(v){return v?Number(v).toLocaleString():'0'},
    formatPrice(v){return v?Number(v).toLocaleString():'0'},
    fmtD(d){return d?new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short',year:'numeric'}):''},
    isAf(st){if(!this.order||!this.order.status)return false;var o=['pending_payment','payment_initiated','stk_sent','paid','confirmed','in_transit','delivered','inspection','completed'];return o.indexOf(this.order.status)>=o.indexOf(st)},
    async resendCartStk(){
      this.resendCartError=''; this.resendCartSent=false;
      var userId = sessionStorage.getItem('userId');
      if (!userId || !this.order.order_group_id) return;
      // Use the previously-paid phone if available, else the buyer's profile phone, else prompt
      var phone = (this.order.groupPayment && this.order.groupPayment.payer_phone) || sessionStorage.getItem('userPhone') || this.order.buyer_phone || '';
      var entered = window.prompt('Enter the M-Pesa phone number to receive the prompt (use 07XX or 2547XX):', phone || '');
      if (!entered) return;
      var phoneRaw = String(entered).replace(/\D/g, '');
      if (phoneRaw.length < 9) { this.resendCartError = 'Invalid phone'; return; }
      var phoneNorm = phoneRaw.charAt(0) === '0' ? ('254' + phoneRaw.substring(1))
                    : (phoneRaw.length === 9 ? ('254' + phoneRaw) : phoneRaw);
      this.resendingCart = true;
      try {
        var f = new FormData();
        f.append('function','retryCartPayment');
        f.append('userId', userId);
        f.append('orderGroupId', this.order.order_group_id);
        f.append('phone', phoneNorm);
        var r = await execute(f, flocker);
        if (r.data && r.data.success) {
          this.resendCartSent = true;
          // Reload after a few seconds to pick up the new payment row
          var self = this; setTimeout(function(){ self.load(); }, 8000);
        } else {
          this.resendCartError = (r.data && r.data.message) || 'Could not resend the prompt';
        }
      } catch(e) {
        this.resendCartError = 'Network error — please try again';
      }
      this.resendingCart = false;
    },
    async load(){
      this.loading = true;
      this.loadError = '';
      try {
        var f = new FormData();
        f.append('function','getOrder');
        f.append('orderId', this.$route.params.id);
        var r = await execute(f, flocker);
        if (r.data && r.data.success) {
          this.order = r.data.data.order || {};
          if (!this.payPhone) {
            var ph = sessionStorage.getItem('userPhone') || '';
            this.payPhone = ph.replace('+254','').replace('254','');
          }
          this.initReleaseTimer();
        } else {
          this.loadError = (r.data && r.data.message) || 'Order not found';
        }
      } catch(e) {
        console.error('[OrderDetail] load failed:', e);
        // axios timeout reports e.code === 'ECONNABORTED'
        this.loadError = (e && e.code === 'ECONNABORTED')
          ? 'The server took too long to respond. Tap Retry to try again.'
          : ((e && e.message) || 'Failed to load this order.');
      }
      this.loading = false;
    },

    // === AUTO-RELEASE COUNTDOWN ===
    initReleaseTimer(){
      this.stopReleaseTimer();
      var o=this.order;
      if((o.status==='delivered'||o.status==='inspection')&&o.auto_release_at){
        var releaseAt=new Date(o.auto_release_at.replace(/-/g,'/')).getTime();
        var now=Date.now();
        var diff=Math.floor((releaseAt-now)/1000);
        if(diff<=0){this.releaseSeconds=0;this.releaseExpired=true;return;}
        // Calculate total seconds (from delivery to auto_release)
        if(o.actual_delivery_at){
          var delivAt=new Date(o.actual_delivery_at.replace(/-/g,'/')).getTime();
          this.releaseTotalSecs=Math.max(1,Math.floor((releaseAt-delivAt)/1000));
        }else{this.releaseTotalSecs=172800;}
        this.releaseSeconds=diff;
        this.releaseExpired=false;
        var self=this;
        this.releaseTimer=setInterval(function(){
          self.releaseSeconds--;
          if(self.releaseSeconds<=0){self.releaseSeconds=0;self.releaseExpired=true;self.stopReleaseTimer();self.load();}
        },1000);
      }else{this.releaseSeconds=0;this.releaseExpired=false;}
    },
    stopReleaseTimer(){if(this.releaseTimer){clearInterval(this.releaseTimer);this.releaseTimer=null;}},

    // === PAYMENT (STK Push from Order Detail) ===
    async sendStkFromOrder(){
      if(!this.payPhone||this.payPhone.length<9){this.stkError='Enter a valid phone number';this.stkStatus='failed';return}
      this.stkSending=true;this.stkStatus='';this.stkError='';this.stkReceipt='';
      try{
        var f=new FormData();
        f.append('function','initiatePayment');
        f.append('orderId',this.order.id);
        f.append('userId',sessionStorage.getItem('userId'));
        f.append('paymentMethod','mpesa_stk');
        f.append('phone',this.payPhone);
        f.append('amount',this.order.total_amount);
        var r=await execute(f,flocker);
        if(r.data&&r.data.success){
          this.stkStatus='sent';
          this.stkRef=(r.data.data&&r.data.data.paymentRef)||'';
          this.stkCheckoutId=(r.data.data&&r.data.data.checkoutRequestId)||'';
          this.startStkPoll();
        }else{this.stkStatus='failed';this.stkError=(r.data&&r.data.message)||'STK push failed';}
      }catch(e){this.stkStatus='failed';this.stkError='Network error';}
      this.stkSending=false;
    },
    startStkPoll(){this.stopStkPoll();this.stkCountdown=5;var self=this;this.stkTimer=setInterval(function(){self.stkCountdown--;if(self.stkCountdown<=0){self.stkCountdown=5;self.checkStkStatus();}},1000);},
    stopStkPoll(){if(this.stkTimer){clearInterval(this.stkTimer);this.stkTimer=null;}},
    async checkStkStatus(){
      if(!this.stkRef&&!this.stkCheckoutId)return;
      try{
        var f=new FormData();f.append('function','checkPaymentStatus');
        if(this.stkRef)f.append('paymentRef',this.stkRef);
        if(this.stkCheckoutId)f.append('checkoutRequestId',this.stkCheckoutId);
        var r=await execute(f,flocker);
        if(r.data&&r.data.success&&r.data.data){
          var st=r.data.data.status;
          if(st==='completed'){this.stkStatus='completed';this.stkReceipt=r.data.data.mpesaReceipt||'';this.stopStkPoll();this.load();}
          else if(st==='failed'){this.stkStatus='failed';this.stkError=r.data.data.failureReason||'';this.stopStkPoll();}
          else if(st==='cancelled'){this.stkStatus='cancelled';this.stkError=r.data.data.failureReason||'';this.stopStkPoll();}
        }
      }catch(e){}
    },
    confirmAction(status,title,msg,type){this.confirmStatus=status;this.confirmTitle=title;this.confirmMsg=msg;this.confirmType=type||'success';this.showConfirm=true;this.actMsg='';},
    raiseDispute(){var o=this.order;var other=this.isBuyer?(o.seller_name||''):(o.buyer_name||'');this.$router.push('/disputes?orderId='+o.id+'&orderNumber='+(o.order_number||'')+'&listingTitle='+encodeURIComponent(o.listing_title||'')+'&totalAmount='+(o.total_amount||'')+'&otherParty='+encodeURIComponent(other));},
    leaveReview(){var o=this.order;var sellerId=o.seller_id||'';var sellerName=o.seller_name||'';this.$router.push('/reviews?orderId='+o.id+'&orderNumber='+(o.order_number||'')+'&listingTitle='+encodeURIComponent(o.listing_title||'')+'&sellerId='+sellerId+'&sellerName='+encodeURIComponent(sellerName)+'&contextType=animal_order');},
    async executeConfirmed(){this.actLoading=true;this.actMsg='';var wasComplete=this.confirmStatus==='completed';var amt=this.sellerPayout;var seller=this.order.seller_name;var orderNum=this.order.order_number;try{var f=new FormData();f.append('function','updateOrderStatus');f.append('orderId',this.order.id);f.append('status',this.confirmStatus);f.append('userId',sessionStorage.getItem('userId'));var r=await execute(f,flocker);if(r.data&&r.data.success){this.actOk=true;this.actMsg='Updated!';this.showConfirm=false;if(wasComplete){this.releasedAmount=amt;this.releasedSeller=seller;this.releasedOrder=orderNum;this.showReleaseSuccess=true}this.load()}else{this.actOk=false;this.actMsg=(r.data&&r.data.message)||'Failed';this.showConfirm=false}}catch(e){this.actOk=false;this.actMsg='Error';this.showConfirm=false}this.actLoading=false;},
    async messageOther(){
      var userId=sessionStorage.getItem('userId');var toId=this.otherPartyId;if(!toId)return;
      try{
        // First check if conversation already exists for this order
        var p1=userId<toId?userId:toId;var p2=userId<toId?toId:userId;
        var check=await executeJson({function:'getConversations',userId:userId},flocker);
        var existing=null;
        if(check.data&&check.data.success){
          var convs=check.data.data.conversations||[];
          for(var i=0;i<convs.length;i++){
            var c=convs[i];
            if(c.context_type==='order'&&c.context_id===this.order.id){existing=c;break}
            if((c.participant_one_id===p1&&c.participant_two_id===p2)||(c.participant_one_id===p2&&c.participant_two_id===p1)){
              if(!c.context_type||c.context_type==='general'){existing=c;break}
            }
          }
        }
        if(existing){
          this.$router.push('/messages/'+existing.id);return;
        }
        // No existing conversation — create one with default message
        var otherName=this.isBuyer?(this.order.seller_name||'Seller'):(this.order.buyer_name||'Buyer');
        var listing=this.order.listing_title||this.order.title||'your listing';
        var defaultMsg='Hi '+otherName+', I\'m reaching out regarding Order #'+this.order.order_number+' for '+listing+'. ';
        if(this.isBuyer){defaultMsg+='I\'d like to discuss the delivery details.'}
        else{defaultMsg+='I\'m preparing your order and wanted to confirm the details.'}
        var f=new FormData();f.append('function','sendMessage');f.append('senderId',userId);f.append('receiverId',toId);
        f.append('content',defaultMsg);f.append('contextType','order');f.append('contextId',this.order.id);
        if(this.order.listing_id)f.append('listingId',this.order.listing_id);
        var r=await execute(f,flocker);
        if(r.data&&r.data.success&&r.data.data.conversationId){this.$router.push('/messages/'+r.data.data.conversationId)}
        else{this.$router.push('/messages')}
      }catch(e){this.$router.push('/messages')}
    }
  }
};
</script>